export function shouldBlockCoachNutritionOffline(coach) {
  return coach?.isOffline === true;
}

export function shouldBlockClientNutritionOffline(client) {
  return client?.isOffline === true;
}

export function navigateCoachNutritionOfflineToDashboard(coach) {
  coach?.setProperty?.("showingCoachView", "CoachDashboard");
  coach?.setProperty?.("sideMenuVisible", false);
}

export function navigateClientNutritionOfflineToDashboard(client) {
  client?.setProperty?.("selectedTab", "summary-string");
}
